import * as React from "react";
import { CustomerFormTypeData } from "@plinknz/tah-website-elements";

import { ContactForm } from "./contact-form";
import { KirihimeteWhanauForm } from "./kirihimete-whanau";
import { PuteaTautokoForm } from "./putea-tautoko";
import { RegistrationForm } from "./registration-form";
import { TunaWanangaForm } from "./tuna-wananga";

interface CustomerFormBlockProps {
  data: CustomerFormTypeData;
}

export const CustomerFormBlock = ({
  data: { active, type },
}: CustomerFormBlockProps) => {
  if (!active) {
    return <div data-testid="inactive-form" />;
  }

  switch (type) {
    case "contact":
      return <ContactForm />;
    case "pūteaTautoko":
      return <PuteaTautokoForm />;
    case "registration":
      return <RegistrationForm />;
    case "tuna":
      return <TunaWanangaForm />;
    case "kirihimeteWhānau":
      return <KirihimeteWhanauForm />;
    default:
      return <div data-testid="unknown-form" />;
  }
};
